import { SectionProps } from "@/components/Sections";
import { LearningOpportunity } from "@/server/backend-api";
import { LearningOppPageMetaData } from "../LearningOppMetaData";
import {
  ColumnsSection,
  ColumnsSectionLeft,
  ColumnsSectionRight,
  ColumnsSectionSeperator,
} from "./ColumnsSection";

type Props = SectionProps & {
  heading: string;
  learningOpp: LearningOpportunity;
};

export const LearningOppAttendingMetaSection = ({
  heading,
  learningOpp,
  ...sectionProps
}: Props) => {
  return (
    <ColumnsSection {...sectionProps}>
      <ColumnsSectionLeft>
        <h2 className="text-style-headline2 mb-xs text-light-yellow">
          {heading}
        </h2>
        <div className="text-style-body2">{learningOpp.introduction}</div>
      </ColumnsSectionLeft>
      <ColumnsSectionSeperator />
      <ColumnsSectionRight>
        <LearningOppPageMetaData learningOpp={learningOpp} />
      </ColumnsSectionRight>
    </ColumnsSection>
  );
};
